import { identify } from '../segment/client';

type TypeformEmailType = { type: 'email'; email: string };
type TypeformPhoneType = { type: 'phone_number'; phone_number: string };

interface TypeformResult {
	answers: Array<TypeformEmailType | TypeformPhoneType>;
}

function isEmailType(e: TypeformPhoneType | TypeformEmailType): e is TypeformEmailType {
	return e.type === 'email';
}

function isPhoneType(e: TypeformPhoneType | TypeformEmailType): e is TypeformPhoneType {
	return e.type === 'phone_number';
}

export async function identifySubmission(
	formId: string,
	responseId: string,
	config?: { delay?: number }
) {
	const { delay = 500 } = config || {};

	// wait a bit to ensure that we can fetch the response from the API
	await new Promise((resolve) => setTimeout(resolve, delay));

	const response = await fetch(`/api/typeform/${formId}/${responseId}`);

	if (response.status !== 200) return;

	const result = (await response.json()) as TypeformResult;

	const emailAnswer = result.answers.find(isEmailType);
	const phoneAnswer = result.answers.find(isPhoneType);

	identify({
		email: emailAnswer?.email || '',
		phone: phoneAnswer?.phone_number || ''
	});
}
